var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "singleDisbursementModal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: !_vm.isEdit
              ? _vm.$t("data.add_receiver")
              : _vm.$t("data.edit_receiver"),
            "close-on-click-modal": false,
            width: "508px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-container" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    rules: _vm.rule,
                    model: _vm.form,
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("data.receiver_type"),
                        prop: "receiver_type",
                        required: "",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "select-item",
                          attrs: {
                            filterable: "",
                            clearable: "",
                            disabled: _vm.isEdit,
                          },
                          model: {
                            value: _vm.form.receiver_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "receiver_type", $$v)
                            },
                            expression: "form.receiver_type",
                          },
                        },
                        _vm._l(_vm.receiverTypeMap, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("data.receiver_account"),
                        prop: "receiver_account",
                        required: "",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "input-item",
                        attrs: {
                          clearable: "",
                          type: "text",
                          maxlength: "30",
                          placeholder: _vm.$t("tips.please_enter"),
                          autocomplete: "off",
                          disabled: _vm.isEdit,
                        },
                        model: {
                          value: _vm.form.receiver_account,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "receiver_account", $$v)
                          },
                          expression: "form.receiver_account",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("data.receiver_name"),
                        prop: "receiver_name",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "input-item",
                        attrs: {
                          clearable: "",
                          type: "text",
                          maxlength: "100",
                          placeholder: _vm.$t("tips.please_enter"),
                          autocomplete: "off",
                          disabled: _vm.isEdit,
                        },
                        model: {
                          value: _vm.form.receiver_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "receiver_name", $$v)
                          },
                          expression: "form.receiver_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("data.nick_name"),
                        prop: "remark_name",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "input-item",
                        attrs: {
                          clearable: "",
                          type: "text",
                          maxlength: "30",
                          placeholder: _vm.$t("tips.please_enter"),
                          autocomplete: "off",
                        },
                        model: {
                          value: _vm.form.remark_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark_name", $$v)
                          },
                          expression: "form.remark_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("data.receiver_relation"),
                        prop: "relation_type",
                        required: "",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "select-item",
                          attrs: { filterable: "", clearable: "" },
                          model: {
                            value: _vm.form.relation_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "relation_type", $$v)
                            },
                            expression: "form.relation_type",
                          },
                        },
                        _vm._l(_vm.receiverRelationMap, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.relation_type === 11
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("data.customize"),
                            prop: "custom_relation",
                            required: "",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "input-item",
                            attrs: {
                              clearable: "",
                              type: "text",
                              maxlength: "30",
                              placeholder: _vm.$t("tips.please_enter"),
                              autocomplete: "off",
                            },
                            model: {
                              value: _vm.form.custom_relation,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "custom_relation", $$v)
                              },
                              expression: "form.custom_relation",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("data.relation_document"),
                        prop: "relation_document",
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _vm.form.relation_proof_relative_url
                            ? _c(
                                "div",
                                { staticStyle: { "margin-bottom": "10px" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "content-file" },
                                    [
                                      _vm.isImg(
                                        _vm.form.relation_proof_relative_url
                                      )
                                        ? _c("el-image", {
                                            staticStyle: { height: "150px" },
                                            attrs: {
                                              src: _vm.form
                                                .relation_proof_absolute_url,
                                              "preview-src-list": [
                                                _vm.form
                                                  .relation_proof_absolute_url,
                                              ],
                                            },
                                          })
                                        : _c(
                                            "span",
                                            { on: { click: _vm.onClickFile } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.form
                                                    .relation_proof_relative_url
                                                )
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: {
                                        type: "danger",
                                        size: "mini",
                                        icon: "el-icon-delete",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onClickRemoveBtn()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("components.delete"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "UploadFile",
                                _vm._g(
                                  {
                                    attrs: {
                                      "accept-type": ".jpg,.jpeg,.png,.pdf",
                                      "limit-size": 5,
                                      "file-dir": "SPLIT_PAYMENT_RECEIVER_FILE",
                                    },
                                    on: {
                                      templateFileSuccess:
                                        _vm.templateFileSuccess,
                                    },
                                  },
                                  _vm.$listeners
                                )
                              ),
                          _c("div", { staticStyle: { color: "#a1a1a1" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("tips.split_receiver_upload_tips"))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.cancel")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: { type: "info", disabled: _vm.submiting },
                  on: { click: _vm.onClickSubmitBtn },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }